import React from 'react';
import { OrderbookProduct } from '../../hooks/useOrderbookData';
import { cn } from '../../lib/classNameHelpers';
import { Gwei } from '../../lib/gwei';
import { multiply } from '../../lib/math';
import { InlineSelect } from '../InlineSelect/InlineSelect';
import { SimpleSelect } from '../SimpleSelect/SimpleSelect';

const TICK_MULTIPLIERS = [1, 2, 5, 10, 100, 1000] as const;

const getGroupingOptions = (tickSize: bigint) =>
  TICK_MULTIPLIERS.map((multiplier) => {
    const value = multiply(tickSize, Gwei.toGwei(multiplier));
    const formattedValue = Gwei.fmt(value);

    return {
      value: formattedValue,
      label: formattedValue,
    };
  });

interface OrderbookControlsProps {
  product: OrderbookProduct;
  grouping: string;
  setGrouping: (value: string) => void;
  asset: string;
  setAsset: (value: string) => void;
  className?: string;
}

export const OrderbookControls: React.FC<OrderbookControlsProps> = ({
  product,
  grouping,
  setGrouping,
  asset,
  setAsset,
  className,
}) => {
  const { baseTokenName, quoteTokenName, tickSize } = product;
  const assetOptions = [{ value: baseTokenName }, { value: quoteTokenName }] as const;

  return (
    <div className={cn('flex items-center justify-between px-2', className)}>
      <SimpleSelect
        key={baseTokenName}
        options={getGroupingOptions(tickSize)}
        selected={{ value: grouping, label: grouping }}
        onChange={(option) => option && setGrouping(option?.value)}
        className="gap-2 text-xs font-medium"
      />
      <div>
        <InlineSelect
          className="gap-2"
          key={baseTokenName}
          selected={asset}
          options={assetOptions}
          buttonClassName="!px-0 !py-1"
          onChange={(option) => option && setAsset(option.value)}
          formatTitle={(option) => `Display order sizes in ${option.label ?? option.value}`}
        />
      </div>
    </div>
  );
};
